<template>
    <router-view />
</template>

<script>
export default {
    name: 'CharityReportsRoot',
};
</script>
